import { User } from '../reduxTypes';

const initialState: User = {
  userModules: null,
  login: false,
  userID: ''
};

interface ReduxProps {
  type: string;
  value: any;
}

export default (state = initialState, { type, value }: ReduxProps): User => {
  switch (type) {
    case 'SET_USER_MODULES':
      return {
        ...state,
        userModules: value
      };
    case 'SET_USER_ID':
      return {
        ...state,
        userID: value
      };
    case 'SET_USER_LOGIN':
      return {
        ...state,
        login: value
      };
    default:
      return state;
  }
};
